import { Container, Grid, Paper, Typography, Button, Box, Divider } from '@mui/material';
import { styled } from '@mui/material/styles';
import styles from './specificationsTab.module.css';
import { formateDate } from '../../../../Website/utils/utils';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useCallback, useEffect, useState } from 'react';
import DeliveryAddressPopup from './SelectAddress';
import { toast } from 'react-toastify';
import api from '../../../../Website/utils/api';


const ActionButton = styled(Button)(({ theme }) => ({
    textTransform: 'none',
    fontSize: '014px',
    color: '#667085',
    backgroundColor: '#F0F1F3',
    fontSize: '14px',
    borderRadius: "4px",
    height: "40px",
    fontFamily: `'Public Sans', sans-serif`,
    '&:hover': {
        backgroundColor: theme.palette.grey[200],
    },
}));


const EnquiryDeets = ({ data, enquiryId, from }) => {
    const navigate = useNavigate()
    const dispatch = useDispatch();
    const [selectedProducts, setSelectedProductsState] = useState([]);
    const [open, setOpen] = useState(false);
    const [selectedAddress, setSelectedAddress] = useState(null);

    const handleCheckboxChange = (item) => {
        setSelectedProductsState((prev) => {
            const isAlreadySelected = prev.find((p) => p?.productNumber === item?.productNumber);
            if (isAlreadySelected) {
                return prev.filter((p) => p?.productNumber !== item?.productNumber); // Unselect
            } else {
                return [...prev, item]; // Select
            }
        });
    };

    useEffect(() => {
        if (data?.partList?.length > 0) {
            handleSelectAll(data?.partList, true)
        }
    }, [data?.partList])


    const totalPrice = selectedProducts?.reduce((sum, item) => sum + (item.quotePrice), 0);


    const handleSaveSelection = async () => {
        const order = {
            total: totalPrice,
            partList: selectedProducts,
            projectName: data?.projectName,
            application: data?.application,
            anualVolume: data?.anualVolume,
            endCustomer: data?.endCustomer,
            enquiryType: data?.enquiryType,
            orderType: from == "BOM" ? "BOM" : from == "Wizard" ? "WIZARD" : "EXCESS",
            sop: data?.sop,
            shippingAddress: selectedAddress,
            enquiryId
        }

        try {
            const response = await api.createPoOrder(order)
            if (response.data) {
                toast.success('Order created succefully')
                navigate('/userEnquires')
            }
        } catch (err) {
            console.log(err);
            toast.error(err?.response?.data?.message || 'something went wrong')
        }
        finally {
            setOpen(false)
        }
        // dispatch(setSelectedProducts(selectedProducts));
    };

    const handleSelectAll = useCallback((products, checked) => {
        if (checked) {
            setSelectedProductsState(products)
        } else {
            setSelectedProductsState([])
        }
    }, [data?.partList]);


    console.log("datapart-list", data?.partList)
    return (
        <div className={styles.profilebodyContainer}>
            <div className={styles.profileheader}>
                <Box display="flex" alignItems="center" >
                    <h2>Enquiry Details</h2>
                    <Typography style={{ margin: '6px' }}>•</Typography>
                    <Typography style={{ padding: "6px 4px", borderRadius: '8px', fontSize: '14px', color: '#4D4D4D' }}>
                        {data?.enquiryId}
                    </Typography>
                    <Typography style={{ margin: '6px' }}>•</Typography>
                    <Typography style={{ padding: "6px 4px", borderRadius: '8px', fontSize: '14px', color: '#4D4D4D' }}>

                        {formateDate(data?.createdAt)}
                    </Typography>
                    <Typography style={{ margin: '6px' }}>•</Typography>
                    <Typography style={{ padding: "6px 4px", borderRadius: '8px', fontSize: '14px', color: '#4D4D4D' }}>

                        Created by {data?.user?.fullName}
                    </Typography>
                </Box>
                <button className={styles.editbtn} onClick={() => navigate(-1)}>Back to List</button>
            </div>
            <Paper sx={{ boxShadow: 'none', background: 'transparent', border: '1px solid #DCDEE3', borderRadius: "4px", margin: "16px" }}>
                <Box sx={{ padding: '10px 16px' }} display="flex" justifyContent="space-between" >
                    <Box display="flex" alignItems="center" gap='18px'>
                        <Box display="flex" alignItems="flex-start" flexDirection='column'>
                            <Typography style={{ padding: "6px 0px", borderRadius: '8px', fontSize: '14px', color: '#999999' }}>
                                Enquiry #
                            </Typography>
                            <Typography style={{ fontSize: '14px', fontWeight: "500", }}>
                                {data?.enquiryId}
                            </Typography>
                        </Box>
                        <Box display="flex" alignItems="center">
                            <svg width="2" height="40" viewBox="0 0 2 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1 0L1 40" stroke="#E6E6E6" />
                            </svg>
                        </Box>
                        <Box display="flex" alignItems="flex-start" flexDirection='column'>
                            <Typography style={{ padding: "6px 0px", borderRadius: '8px', fontSize: '14px', color: '#999999' }}>
                                Status
                            </Typography>
                            <Typography style={{ fontSize: '14px', fontWeight: "500", color: data?.status == "NEW" ? "#4A4C56" : data?.status == "QUOTED" ? "#F86624" : "#1A9882" }}>
                                {data?.status == 'NEW' ? 'Pending' : data?.status}
                            </Typography>
                        </Box>
                    </Box>
                    <Box display="flex" alignItems="center" >
                        {data?.status == 'NEW' ?
                            <ActionButton> Quote details</ActionButton>
                            :
                            data?.status == 'COMPLETED' ? null :
                                selectedProducts?.length <= 0 ?
                                    <ActionButton>Accept & Create Order </ActionButton>
                                    :
                                    <button className={styles.submitBtn} onClick={() => setOpen(true)}>Accept & Create Order ({selectedProducts?.length} item)</button>
                        }
                    </Box>
                </Box>
            </Paper>

            {
                data?.status == "QUOTED" && <div style={{ display: "flex", gap: 5, alignItems: "center" }}>
                    <input
                        type="checkbox"
                        checked={selectedProducts?.length === data?.partList?.length}
                        onChange={(e) =>
                            handleSelectAll(data?.partList, e.target.checked)
                        }
                    />

                    Select All | {selectedProducts?.length} Selected

                </div>
            }

            <table className={styles.previewtable}>
                <thead>
                    <tr>
                        <th className={styles.previewth} style={{ borderRight: '1px solid #0000001A' }}>Sl No</th>
                        <th className={styles.previewth} style={{ borderRight: '1px solid #0000001A' }}>Manufacture Part #</th>
                        <th className={styles.previewth} style={{ borderRight: '1px solid #0000001A' }}>Quantity</th>
                        <th className={styles.previewth}>Manufacture/purchase order #</th>
                        {data?.status == 'QUOTED' &&
                            <>
                                <th className={styles.previewth}>Price</th>
                                <th className={styles.previewth}>MOQ</th>
                            </>
                        }

                    </tr>
                </thead>
                <tbody>
                    {data?.partList?.map((item, index) => (
                        <tr key={item.productNumber} className={styles.previewstripedRow}>
                            <td className={styles.previewtd} style={{ borderRight: '1px solid #0000001A', display: 'flex', alignItems: 'center', gap: 10 }}>
                                {data?.status == 'QUOTED' &&
                                    <input
                                        type="checkbox"
                                        checked={selectedProducts?.some((p) => p.productNumber === item.productNumber)}
                                        onChange={() => handleCheckboxChange(item)}
                                    />
                                }
                                {index + 1}

                            </td>
                            <td className={styles.previewtd} style={{ borderRight: '1px solid #0000001A' }}>{item.productNumber}</td>
                            <td className={styles.previewtd} style={{ borderRight: '1px solid #0000001A' }}>{item.quantity}</td>
                            <td className={styles.previewtd}>
                                {item.manufacturer}
                            </td>
                            {data?.status == 'QUOTED' &&
                                <>
                                    <td className={styles.previewtd}>
                                        {item?.quotePrice}
                                    </td>
                                    <td className={styles.previewtd}>
                                        {item.moq}
                                    </td>
                                </>
                            }
                        </tr>
                    ))}
                </tbody>
            </table>
            <DeliveryAddressPopup
                selectedAddress={selectedAddress}
                setSelectedAddress={setSelectedAddress}
                setOpen={setOpen}
                open={open}
                handleSubmit={handleSaveSelection}
            />
        </div>
    )
}

export default EnquiryDeets